import React, { useEffect, useRef, useState } from 'react';
import AdminHeader from './AdminHeader.js';
import { Link } from 'react-router-dom';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { createRoot } from 'react-dom/client';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_ORDERS, GET_ORDERS_BY_ID } from '../graphql/Query/Order.js';
import moment from 'moment';
import Table from "../components/Table/index.jsx";
import Loader from '../components/Loader.js';
import CustomPagination from '../components/Pagination.js';
import useScrollToTop from '../components/useScrollToTop.js';
import Select from "react-select";
import * as XLSX from 'xlsx';
import NoDataFound from '../components/NoDataFound.js';
import { FiDownload } from 'react-icons/fi';
import { warehouseOptions } from '../DomesticSellerOrder/AllOrderSeller.js';
import { allowedPincodes } from '../OrderPage/PincodeService.js';
import CustomLabel from '../Common/CustomLabel.js';
import { handleDownload } from '../Common/DownloadLabel.js';
import DataTable from "react-data-table-component";
import { capitalizeFirstLetter } from '../OrderPage/AllOrders.js';

export const typeOptions = [
    { value: "", label: "All" },
    { value: "cod", label: "COD" },
    { value: "prepaid", label: "Prepaid" },

];

const AdminTodayOrder = () => {
    useScrollToTop();
    const invoiceRef = useRef(null);
    const [activeButton, setActiveButton] = useState('');
    const [paymentCf, setPaymentCf] = useState('');
    const [selectedDayRange, setSelectedDayRange] = useState(""); // Logical value
    const [displayedDayRange, setDisplayedDayRange] = useState({ label: "All", value: "" }); // Displayed value
    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [filter, setFilter] = useState('');
    const [todayTicketCount, setTodayTicketCount] = useState(0);
    const [cancelCourier, setCancelCourier] = useState();
    const [paymentStatus, setpaymentStatus] = useState();
    const [orderStatus, setorderStatus] = useState('');
    const [cancelOrder, setCancelOrder] = useState(0);
    const [GetOrderOrderData, { loading: loadingDataDownload }] = useLazyQuery(GET_ORDERS_BY_ID, {
        fetchPolicy: "cache-and-network"
    });
    const [singleOrderLabel, setSingleOrderLabel] = useState();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(100);

    const { data, loading } = useQuery(GET_ORDERS, {
        variables: {
            "page": page,
            "limit": limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter,
            "from": fromDate,
            "to": toDate,
            "orderStatus": cancelCourier,
            "paymentStatus": paymentStatus,
            paymentType: orderStatus,
            dayRange: selectedDayRange

        },
        fetchPolicy: 'cache-and-network'
    });

    useEffect(() => {
        if (data?.getOrders?.data) {
            const today = moment().startOf('day');
            const todayTickets = data?.getOrders?.data?.filter((ticket) => moment(ticket.createdAt).isSame(today, 'day'));

            const canceledOrder = data?.getOrders?.data?.filter((order) =>
                order.status === 'cancelled' && moment(order.createdAt).isSame(today, 'day')
            );
            setCancelOrder(canceledOrder?.length);
            setTodayTicketCount(todayTickets?.length);
        }
    }, [data]);

    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }

    const searchCustomerUser = () => {
        setFilter(searchUser);
        setPage(1);
    }

    const handleSearch = (e) => {
        searchCustomerUser()
    }

    const handleReset = () => {
        setFromDate('');
        setToDate('');
        setFilter('');
        setSearchUser('');
        setCancelCourier('');
        setpaymentStatus("");
        setPage(1);
        setpaymentStatus('');
        setPaymentCf('');
        setorderStatus('');
        setActiveButton("")
        setSelectedDayRange("")
        setDisplayedDayRange({ label: "All", value: "" }); // Display "All" in the Select dropdown

    }

    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
    };

    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId?.name || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';

            return {
                No: index,
                "Shipment Date": shipment?.createdAt ? moment(shipment?.createdAt).format('DD/MM/YYYY') : "-",
                "Delivered Date": shipment?.delivery_order_Date ? moment(shipment?.delivery_order_Date).format('DD/MM/YYYY') : "-",
                AWB: shipment?.awb_number ? shipment?.awb_number : "-",
                "Order ID": shipment?.order_id ? shipment?.order_id : "-",
                "Order Number": shipment?.order_number ? shipment?.order_number : "-",
                "Payment Type": shipment?.payment_type ? shipment?.payment_type : "-",
                "Receiver Name (To)": shipment?.deliveryAddress?.name,
                State: state,
                Address: fullAddress,
                City: city,
                "Zip Code": zipCode,
                // "phone":demoo,
                "Weight (Kg)": shipment?.package_weight_Length,
                Status: shipment?.status,
                Product: shipment?.ProductName,
                "COD Collectable Rs.": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : "-",
                "COD Collection Rs.": `${shipment?.codCollectableValue}`,
                "RTO Charges": `${shipment?.rto_order_charge || 0}`,
                "Shipment Charge": `₹${shipment?.order_amount}`,
                "Total Amount": `${shipment?.final_order_amount || 0}`,
                "Total Receivable Amount": `${shipment?.net_receivable_amount || 0}`,
                "payment Status": `${shipment?.cod_payment_status || '-'}`
            };
        });
    };

    const downloadExcel = () => {
        if (!data?.getOrders?.data?.length) return;

        // Transform data
        const transformedData = transformDataForExport(data?.getOrders?.data);

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Shipments");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "shipments.xlsx");
    };

    const handleDownloadLabel = async (id) => {
        const GetOrderOrderDataValue = await GetOrderOrderData({
            variables: {
                "getOrderId": id,
            },
        });

        setSingleOrderLabel(GetOrderOrderDataValue?.data?.getOrder);
    }
    useEffect(() => {
        const generatePDF = async () => {
            if (!singleOrderLabel) return;

            const doc = new jsPDF("p", "pt", [300, 460]); // 4x6 inches
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-9999px";
            container.style.visibility = "visible";
            document.body.appendChild(container);

            const root = createRoot(container);
            root.render(<CustomLabel key={singleOrderLabel?._id} order={singleOrderLabel} />);

            await new Promise((resolve) => setTimeout(resolve, 500));

            try {
                const canvas = await html2canvas(container, { scale: 2 });
                const imgData = canvas.toDataURL("image/png");
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                doc.save(`${singleOrderLabel?.order_number}_UK_Logistics.pdf`);
                setSingleOrderLabel()
            } catch (error) {
                console.error("Error generating label:", error);
            }

            root.unmount();
            document.body.removeChild(container);
        };

        generatePDF();
    }, [singleOrderLabel])
    const handlePagination = (page) => {
        // setLoader(true);
        setPage(page?.selected);
    };

    const columns = [
        { name: "No.", selector: (row, index) => index + 1 + ((page - 1) * limit), sortable: true },

        { name: "Shipment Date", selector: row => moment(row?.createdAt).format("DD/MM/YYYY hh:mm A"), sortable: true },
        { name: "Delivered Date", selector: row => row?.delivery_order_Date ? moment(row?.delivery_order_Date).format("DD/MM/YYYY hh:mm A") : "-", sortable: true },
        { name: "AWB No.", selector: row => row?.awb_number || "----" },
        { name: "Customer Name", selector: row => row?.pickupAddress?.name || "----" },
        { name: "Receivable Name", selector: row => row?.deliveryAddress?.name || "----" },

        {
            name: "Pickup Address",
            selector: row =>
                `${row?.pickupAddress?.address1 || "----"}, ${row?.pickupAddress?.city || "----"}, ${row?.pickupAddress?.stateId?.name || "----"} - ${row?.pickupAddress?.zipCode || "----"}`,
            cell: (row) => (
                <div className="truncate max-w-xs cursor-pointer" title={
                    `${row?.pickupAddress?.address1 || "----"}, ${row?.pickupAddress?.city || "----"}, ${row?.pickupAddress?.stateId?.name || "----"} - ${row?.pickupAddress?.zipCode || "----"}`
                }>
                    {row?.pickupAddress?.address1 || "----"}
                </div>
            ),
        },
        {
            name: "Delivery Address",
            selector: row =>
                `${row?.deliveryAddress?.address1 || "----"}, ${row?.deliveryAddress?.city || "----"}, ${row?.deliveryAddress?.stateId?.name || "----"} - ${row?.deliveryAddress?.zipCode || "----"}`,
            cell: (row) => (
                <div className="truncate max-w-xs cursor-pointer" title={
                    `${row?.deliveryAddress?.address1 || "----"}, ${row?.deliveryAddress?.city || "----"}, ${row?.deliveryAddress?.stateId?.name || "----"} - ${row?.deliveryAddress?.zipCode || "----"}`
                }>
                    {row?.deliveryAddress?.address1 || "----"}
                </div>
            ),
        }, {
            name: "Receiver Details & Address",
            sortable: true,
            selector: (row) => `${row?.deliveryAddress?.name} - ${row?.deliveryAddress?.address}`,
            // cell: (row, index, allRows) => {
            //     const isSingleRow = allRows.length === 1; // Check if there’s only one row
            //     const tooltipClass = isSingleRow || index < 4 ? "tooltip-below" : "tooltip-above";

            //     return (
            //         <div className="tooltip-container">
            //             {row?.deliveryAddress?.name}
            //             <span className={`tooltip-text ${tooltipClass}`}>
            //                 Name. {capitalizeFirstLetter(row?.deliveryAddress?.name)} <br />
            //                 To. {capitalizeFirstLetter(row?.deliveryAddress?.address1)}{" "}
            //                 {capitalizeFirstLetter(row?.deliveryAddress?.city)}.{" "}
            //                 {capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name)} -{" "}
            //                 {row?.deliveryAddress?.zipCode} <br />
            //                 Mo. {row?.deliveryAddress?.phone}
            //             </span>
            //         </div>
            //     );
            // },
            cell: (row) => (
                <div className="tooltip-container">
                    {row?.deliveryAddress?.name}
                    <div className="tooltip-text tooltip-above">
                        Name. {capitalizeFirstLetter(row?.deliveryAddress?.name)} <br />
                        To. {capitalizeFirstLetter(row?.deliveryAddress?.address1)}{" "}
                        {capitalizeFirstLetter(row?.deliveryAddress?.city)}.{" "}
                        {capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name)} -{" "}
                        {row?.deliveryAddress?.zipCode} <br />
                        Mo. {row?.deliveryAddress?.phone}
                    </div>
                </div>
            ),
        },
        { name: "Shipment Id", selector: row => row?.order_id || "----" },
        { name: "Shipment No", selector: row => row?.order_number || "----" },
        { name: "Status", selector: row => row?.status || "----" },
        { name: "CF Status", selector: row => row?.paymentStatus || "----" },
        { name: "Payment Type", selector: row => row?.payment_type || "----" },
        { name: "Cod Collectable", selector: row => (row?.payment_type === "cod" ? row?.ProductPrice || 0 : "-") },
        { name: "Cod Collection", selector: row => row?.codCollectableValue || 0 },
        { name: "Prepaid Product Price", selector: row => (row?.payment_type === "prepaid" ? row?.ProductPrice || 0 : "-") },
        { name: "RTO Charge", selector: row => row?.rto_order_charge || 0 },
        { name: "Shipment Amount", selector: row => row?.order_amount || 0 },
        { name: "Final Shipment Amount", selector: row => row?.final_order_amount || 0 },
        { name: "Payable Total Amount", selector: row => row?.net_receivable_amount || 0 },
        {
            name: "Label", cell: row => (
                <>
                    <button onClick={() => handleDownload(row?.label, row?.Shipment_name)} className="px-3 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white">Download Label</button>

                </>
            )
        },
        {
            name: "Custom Label", cell: row => (
                <>
                    {allowedPincodes.includes(row?.pickupAddress?.zipCode) && (
                        <button onClick={() => handleDownloadLabel(row?.id, "label")} className="ml-2 px-3 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white">Custom Label</button>
                    )}
                </>
            )
        },
        { name: "Full Details", cell: row => (<Link to='/admintrack' state={{ id: row?.id }} className="text-blue-400 font-semibold">View Details</Link>) }
    ];


    return (
        <div>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-8 my-10 ">
                <div className='flex flex-wrap justify-between'>
                    <div>
                        <h2 className="text-lg font-semibold text-green-500">All Shipment</h2>
                    </div>

                    <div className='flex mt-3 md:mt-0 flex-wrap'>
                        <h2 className="text-lg font-semibold me-5 text-green-500">Today Shipment - {todayTicketCount}</h2>
                        <h2 className="text-lg font-semibold text-red-500 mt-2 md:mt-0">Today Canceled Shipment - {cancelOrder}</h2>
                    </div>
                </div>
                <div className='p-4 max-w-full mx-auto bg-slate-50 ring-1 ring-gray-200 rounded-xl space-y-4'>
                    <div className='flex flex-wrap justify-between '>
                        <div>
                            <h2 className="text-lg font-bold mb-3 md:mb-0">Pickup Filters</h2>
                        </div>
                        <div className=''>
                            <button
                                className={`px-4 py-1 border rounded-md ${activeButton === 'reset' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('reset');
                                    handleReset();
                                }}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                    <div className='flex flex-wrap justify-between '>
                        <div className='mt-4'>

                            <button
                                className={`px-4 py-1 mx-3 mb-2 border rounded-md ${activeButton === 'cancelled' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('cancelled');
                                    setCancelCourier('cancelled');
                                }}
                            >
                                Cancel Shipment
                            </button>
                            <button
                                className={`px-4 py-1 border rounded-md ${activeButton === 'pending' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('pending');
                                    setCancelCourier('pending');
                                }}
                            >
                                Pending
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'booked' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('booked');
                                    setCancelCourier('booked');
                                }}
                            >
                                Booked
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'pending pickup' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('pending pickup');
                                    setCancelCourier('pending pickup');
                                }}
                            >
                                Pending Pickup
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'in transit' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('in transit');
                                    setCancelCourier('in transit');
                                }}
                            >
                                In Transit
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'out for delivery' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('out for delivery');
                                    setCancelCourier('out for delivery');
                                }}
                            >
                                Out For Delivery
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'delivered' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('delivered');
                                    setCancelCourier('delivered');
                                }}
                            >
                                Delivered
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'rto' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('rto');
                                    setCancelCourier('rto');
                                }}
                            >
                                RTO
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'exception' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'}`}
                                onClick={() => {
                                    setActiveButton('exception');
                                    setCancelCourier('exception');
                                }}
                            >
                                exception
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'rto delivered' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('rto delivered');
                                    setCancelCourier('rto delivered');
                                }}
                            >
                                RTO Delivered
                            </button>

                            {/* <br className='mb-5' /> */}
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white"
                                onClick={() => { setpaymentStatus('ACTIVE'); }}
                            >
                                ACTIVE CF
                            </button> */}
                            <button
                                className={`px-4 py-1 border rounded-md ${paymentCf === 'ACTIVE' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('ACTIVE');
                                    setpaymentStatus('ACTIVE');
                                }}
                            >
                                CF Active
                            </button>
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white"
                                onClick={() => { setpaymentStatus('Success'); }}
                            >
                                Success CF
                            </button> */}
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${paymentCf === 'SUCCESS' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('SUCCESS');
                                    setpaymentStatus('SUCCESS');
                                }}
                            >
                                CF Success
                            </button>
                            <button
                                className={`px-4 py-1 border rounded-md ${paymentCf === 'NOT_ATTEMPTED' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('NOT_ATTEMPTED');
                                    setpaymentStatus('NOT_ATTEMPTED');
                                }}
                            >
                                CF Not_Attempted
                            </button>
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white"
                                onClick={() => { setpaymentStatus('Failure'); }}
                            >
                                Failure CF
                            </button> */}


                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${paymentCf === 'FAILED' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('FAILED');
                                    setpaymentStatus('FAILED');
                                }}
                            >
                                CF Failed
                            </button>
                            <button
                                className={`px-4 py-1 border rounded-md ${paymentCf === 'USER_DROPPED' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('USER_DROPPED');
                                    setpaymentStatus('USER_DROPPED');
                                }}
                            >
                                CF User_Dropped
                            </button>
                            {/* setpaymentStatus */}
                        </div>

                    </div>

                    <div className='lg:flex space-y-7 lg:space-y-0 lg:justify-between'>
                        <div>
                            <p className="text-sm font-medium text-gray-700">Search</p>
                            <div className='md:flex md:space-x-4 space-x-0'>
                                <div>
                                    <input type="text" onChange={(e) => setSearchUser(e.target.value)} onKeyDown={handleSearch} value={searchUser} placeholder="Search..." className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none p-1.5 border rounded-md" />                                </div>
                            </div>
                        </div>

                        <div className='md:flex md:space-x-9 space-x-0 space-y-3 md:space-y-0'>
                            <div className="">
                                <label className="text-sm text-gray-700 mb-2">Type</label>
                                <Select
                                    options={typeOptions}
                                    defaultValue={typeOptions[0]}
                                    className="w-full"
                                    onChange={(selectedOption) => { setorderStatus(selectedOption?.value); }}
                                    classNamePrefix="react-select"
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? '#64748B' : '#64748B',
                                            '&:hover': { borderColor: '#64748B' },
                                            boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                            borderRadius: '0.375rem',
                                            // paddingTop: '-0.5px', // py-1 corresponds to 0.25rem (4px) on top
                                            // paddingBottom: '-0.5px',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            color: '#000000',
                                            fontSize: '0.875rem',
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? 'white' : '#000000',
                                            fontSize: '0.875rem',
                                            '&:hover': {
                                                backgroundColor: '#f0f0f0',
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '0.875rem',
                                            color: '#A3AAB5',
                                        }),
                                    }}
                                />
                            </div>
                            <div className="">
                                <label className="text-sm text-gray-700 mb-1">Date Range</label>
                                <Select
                                    options={warehouseOptions}
                                    // defaultValue={warehouseOptions[0]}
                                    className="w-full"
                                    value={displayedDayRange} // Controls the displayed value
                                    onChange={(selectedOption) => {
                                        setSelectedDayRange(selectedOption?.value); // Update logical value
                                        setDisplayedDayRange(selectedOption); // Update displayed value
                                    }}
                                    classNamePrefix="react-select"
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? '#64748B' : '#64748B',
                                            '&:hover': { borderColor: '#64748B' },
                                            boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                            borderRadius: '0.375rem',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            color: '#000000',
                                            fontSize: '0.875rem', // Tailwind text-sm equivalent
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? 'white' : '#000000',
                                            fontSize: '0.875rem',
                                            '&:hover': {
                                                backgroundColor: '#f0f0f0',
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '0.875rem', // Tailwind text-sm equivalent
                                            color: '#A3AAB5',
                                        }),
                                    }}
                                />
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-700">From</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <input
                                        type="date"
                                        className="mt-1 w-full md:w-none p-1.5 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 border rounded-md"
                                        value={fromDate}
                                        onChange={(e) => { fromDateChange(e) }}
                                    />
                                </div>
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-700">To</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <div>
                                        <input
                                            type="date"
                                            className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none p-1.5 border rounded-md"
                                            value={toDate}
                                            onChange={(e) => toDateChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=''>
                    <div className='justify-end flex  '>
                        {/* <div className='mt-2' >
                            <label >
                                Items per page:
                                <select value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
                                 
                                    <option value={100}>100</option>
                                    <option value={50}>50</option>
                                </select>
                            </label>
                        </div> */}

                        <div>
                            {/* {data?.getOrders?.count > 0 && (
                                <CustomPagination
                                    totalItems={data?.getOrders?.count || 0}
                                    limit={limit}
                                    pageNo={page}
                                    handlePageClick={handlePageClick}
                                />)} */}
                            <button
                                onClick={downloadExcel}
                                className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                            >
                                <FiDownload className="mr-2 text-lg sm:text-xl" />
                                Export
                            </button>

                        </div>
                    </div>
                </div>
                <div className="mt-2 bg-white p-4 border rounded-lg">
                    <Table
                        columns={columns}
                        data={data?.getOrders?.data || []}
                        currentPage={page}
                        totalRecords={data?.getOrders?.count || 0}
                        limit={limit}
                        setLimit={setLimit}
                        setPage={setPage}
                        loading={loading}
                        // deleteData={DeleteProduct}
                        // onSort={handleSort}
                        handlePagination={handlePagination}
                    // multiSelectRow={onSelectedRowsChange}
                    />
                </div>
                {/* 
                <div className="overflow-x-auto rounded-t-xl  border border-gray-200">
                    <p className='font-semibold m-3'>Total : {data?.getOrders?.count}</p>
                    <table className="min-w-full bg-white">
                        <thead>
                            <tr>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">No.</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Shipment Date</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Delivered Date</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">AWB No.</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Customer Name</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Receivable Name</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Pickup Address</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Delivery Address</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Shipment Id</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Shipment No</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Status</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">CF Status</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Payment Type</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Cod Collectable </td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Cod Collection </td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Prepaid Product Price</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">RTO Charge</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Shipment Amount</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Final Shipment Amount</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Payble Total Amount</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Label</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Custom Label</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Full Details</td>
                            </tr>
                        </thead>
                        {loading ?
                            <Loader className="mx-auto" />
                            : (
                                <tbody>

                                    {data?.getOrders?.count > 0 && data?.getOrders?.data && data?.getOrders?.data.map((row, index) => (
                                        <tr key={index} className='hover:bg-slate-50'>
                                            <td className="py-2.5 text-sm px-4 border-b">{index + 1 + (page * limit)}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{moment(row?.createdAt).format('DD/MM/YYYY hh:mm A')}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.delivery_order_Date ? moment(row?.delivery_order_Date).format('DD/MM/YYYY hh:mm A') : '-'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.awb_number || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.pickupAddress?.name || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.deliveryAddress?.name || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.pickupAddress?.address1 || '----'} , {row?.pickupAddress?.city || '----'} , {row?.pickupAddress?.stateId?.name || '----'} - {row?.pickupAddress?.zipCode || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.deliveryAddress?.address1 || '----'} , {row?.deliveryAddress?.city || '----'} , {row?.deliveryAddress?.stateId?.name || '----'} - {row?.deliveryAddress?.zipCode || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.order_id || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.order_number || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.status || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.paymentStatus || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.payment_type || '----'}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">
                                                {row?.payment_type === 'cod'
                                                    ? row?.ProductPrice || 0
                                                    : '-'}
                                            </td>
                                            <td className="py-2.5 text-sm px-4 border-b">
                                                {
                                                    row?.codCollectableValue || 0
                                                }
                                            </td>
                                            <td className="py-2.5 text-sm px-4 border-b">
                                                {row?.payment_type === 'prepaid'
                                                    ? row?.ProductPrice || 0
                                                    : '-'}
                                            </td> <td className="py-2.5 text-sm px-4 border-b">{row?.rto_order_charge ? row?.rto_order_charge : 0}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.order_amount ? row?.order_amount : 0}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.final_order_amount ? row?.final_order_amount : 0}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.net_receivable_amount ? row?.net_receivable_amount : 0}</td>
                                            <td className="py-2.5 text-sm px-4 border-b"><button
                                                onClick={() => {
                                                    handleDownload(row?.label, row?.Shipment_name)
                                                }}
                                                className='px-3 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white'
                                            >
                                                Download Label
                                            </button></td>
                                            {allowedPincodes.includes(row?.pickupAddress?.zipCode) && <td className="py-2.5 text-sm px-4 border-b"><button
                                                onClick={() => handleDownloadLabel(row?.id, "label")}
                                                className='px-3 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white'
                                            >
                                                custom Label
                                            </button></td>}
                                            <td className="py-2.5 text-sm px-4 border-b text-blue-400 font-semibold"><Link to='/admintrack' state={{ id: row?.id }}> View Details</Link></td>
                                        </tr>
                                    ))}
                                </tbody>
                            )}
                    </table>
                </div> */}

                <div id="label" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px' }}>
                    <CustomLabel ref={invoiceRef} order={singleOrderLabel} />
                </div>
            </div>
        </div>
    )
}

export default AdminTodayOrder;